import { Modal, Typography } from "antd";
import React, { FC } from "react";
import OfficeLoginBtn from "./OfficeLoginBtn";
import GoogleLoginBtn from "./GoogleLoginBtn";

const { Text } = Typography;

interface Props {
  onCancel: () => void;
}

export const AuthFormModal: FC<Props> = (props) => {
  return (
    <Modal
      {...props}
      title={null}
      centered
      open
      footer={null}
      width={420}
      styles={{
        content: {
          borderRadius: '12px',
          overflow: 'hidden',
          padding: 0,
        },
        body: {
          padding: 0,
        }
      }}
    >
      {/* Main Content */}
      <div style={{ padding: '48px 40px 40px' }}>
        {/* Logo and Brand */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '10px',
            marginBottom: '32px',
          }}
        >
          <img
            src="/chronoflow.svg"
            alt="ChronoFlow"
            style={{ height: 36 }}
          />
          <span
            style={{
              fontSize: '24px',
              fontWeight: 600,
              color: '#1a1a2e',
              letterSpacing: '-0.5px',
            }}
          >
            Chronoflow
          </span>
        </div>

        {/* Heading */}
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <h2
            style={{
              margin: '0 0 8px 0',
              fontSize: '22px',
              fontWeight: 600,
              color: '#1a1a2e',
            }}
          >
            Sign in to your account
          </h2>
          <Text style={{ color: '#6b7280', fontSize: '14px' }}>
            Access your recruitment dashboard
          </Text>
        </div>

        {/* Sign In Buttons */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '24px' }}>
          <OfficeLoginBtn />
          <GoogleLoginBtn />
        </div>

        {/* Divider */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            margin: '24px 0',
          }}
        >
          <div style={{ flex: 1, height: '1px', background: '#e5e7eb' }} />
          <span
            style={{
              padding: '0 16px',
              color: '#9ca3af',
              fontSize: '13px',
            }}
          >
            Secure login powered by Microsoft
          </span>
          <div style={{ flex: 1, height: '1px', background: '#e5e7eb' }} />
        </div>

        {/* Security Note */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
            padding: '14px 16px',
            background: '#f9fafb',
            borderRadius: '8px',
            border: '1px solid #f3f4f6',
          }}
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#059669"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
          </svg>
          <Text style={{ color: '#4b5563', fontSize: '13px' }}>
            Enterprise-grade security for your data
          </Text>
        </div>
      </div>

      {/* Footer */}
      <div
        style={{
          textAlign: 'center',
          padding: '16px 40px 20px',
          background: '#fafafa',
          borderTop: '1px solid #f3f4f6',
        }}
      >
        <Text style={{ color: '#9ca3af', fontSize: '12px' }}>
          By continuing, you agree to our{' '}
          <a href="/terms" style={{ color: '#6366f1' }}>
            Terms
          </a>{' '}
          and{' '}
          <a href="/privacy" style={{ color: '#6366f1' }}>
            Privacy Policy
          </a>
        </Text>
      </div>
    </Modal>
  );
};

export default AuthFormModal;
